// @flow
import { Inc, Dec } from './QuantityControls';
import QuantityControl from './QuantityControl';

export { Inc, Dec };
export default QuantityControl;
